module.exports = __webpack_public_path__ + "img/Avatar-19.5ba014cf.svg";